import { Key } from "react";
import PageDescriptionFootnote from "../Footnote";

const PageDescriptionPlano = (props: any) => {

    var RMA = document.querySelector("#RMA");
    var MAT = document.querySelector("#MAT");
    var VITALICIO = document.querySelector("#VITALICIO");
    function renderObjectBody(data: any) {
        return { __html: data }
    }
    return (

        <section className="page-description pt-10">
            <div className="container">
                <div className="row justify-content-center">

                    {props?.items && props?.items?.filter((i: { Identificador: any; }) => i.Identificador === props.page).map((item: 
                    { Descricao_x0020_Subtitulo: any; }, index: Key | null | undefined) => (

                        <div key={index} className="col-lg-10">

                            <div className="page-description__desc mb-7 mb-lg-9">
                                <p>
                                    <span dangerouslySetInnerHTML={renderObjectBody(item?.Descricao_x0020_Subtitulo)} />
                                </p>

                                <br />
                                <button onClick={() => RMA?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> PERFIS </button>
                                <button onClick={() => MAT?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> MAT VARIÁVEL/COTAS </button>
                                <button onClick={() => VITALICIO?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> VITALÍCIO </button>
                            </div>
                            <div className="page-description__midias">
                                <PageDescriptionFootnote />
                            </div>

                        </div>

                    ))}{props.page == null &&
                        <div className="col-lg-10">

                            <div className="page-description__midias">
                                <PageDescriptionFootnote />
                            </div>

                        </div>

                    }
                </div>
            </div>
        </section>
    )
};
export default PageDescriptionPlano;
